import type { FaireProductEntity } from "../../entity_types/product";

export const p_qv7jpzsb4n: FaireProductEntity = {
  token: "p_qv7jpzsb4n",
  type: "product",
  name: "Jessicurl Gentle Lather Shampoo - 8 oz",
  brandToken: "b_wkvuyha6r2",
  brandName: "Jessicurl",
  imageUrl:
    "https://cdn.faire.com/fastly/0e36ebf1a8a3a225e83660c4ef18b6490e6aab88e0786b79a78824fc729f5869.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b3a8418b2b8e60f3d56cfe8d053fbcae8d098f715cce3b210805bff5fede19fb.jpeg",
    "https://cdn.faire.com/fastly/eef0789636bf8d5fc911bf9f21f2bd68ceb9467602b12ae1c91775990b9c9560.jpeg",
  ],
  priceDollars: 10,
  description:
    "Cruelty Free · Vegan · Gluten Free · Paraben Free · Silicones & SLES/SLS Free\n\nOur most popular size, just right for the shower or beside the sink.\n\nGentle Lather Shampoo is a light lather cleanser that will clean your hair without stripping out the moisture. We use only the most gentle cleansing agents available to create a mild, creamy lather that leaves hair clean, soft and shiny.\n\nIf you have fine hair that gets weighed down easily, you’ll especially love this cleanser because there are no added oils or moisturizers. It is safe for color-treated hair, protein free and is a great cleanser for straight hair as well!\n\n· Sulfate Free Formula\n· For Fine Texture or Straight Hair\n· Lightweight with No Added Oils or Moisturizers\n· Buildable Lather That Isn't Drying\n· Protein Free to Reduce Fade of Color-Treated Hair",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:15.431Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
